module.exports = __webpack_public_path__ + "img/icon4.b81a12b0.png";